<template>
  <div class="flex items-center justify-center h-screen">
    <div class="flex items-center">
      <h1 class="pr-3 mr-3 text-4xl font-extrabold border-r border-gray-200 text-dark">
        404
      </h1>
      <h2 class="text-lg text-gray-700">
        La page que vous avez demandée n'a pas été trouvée.<br/>
        <router-link :to="{ name: 'home' }">
          <u>Retournez sur la page d'accueil</u>
        </router-link>
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
};
</script>
